document.addEventListener('DOMContentLoaded', function () {
  function rebuildColumns($gallery) {
    if (!$gallery || !$gallery.length) return;

    // Clear media-column cũ
    const $colContainer = $gallery.find('.theme-images');
    $colContainer.find('.media-column').remove();
    $colContainer.find('.theme-img').each(function () {
      $(this)
        .appendTo($colContainer)
        .removeClass('theme-img--collage-full theme-img--collage-last');
    });

    // Lấy số cột
    const columns = parseInt($gallery.data('column-count'), 10) || 1;
    const isCollage = $gallery.data('layout') === 'collage';
    const $elements = $gallery.find('.theme-img:visible');
    if (columns <= 1 || $elements.length <= 1) return;

    // Tính số ảnh mỗi cột
    const elementsPerCol = Math.ceil($elements.length / columns);
    let currentCol = -1;

    // Build lại column
    $elements.each(function (i) {
      if (currentCol < Math.floor(i / elementsPerCol)) {
        currentCol++;
        $('<div class="media-column"></div>').appendTo($colContainer);
      }
      $colContainer.find('.media-column').last().append($(this));
    });

    // Collage cuối
    if (isCollage) {
      $colContainer.find('.theme-img').last()
        .addClass('theme-img--collage-full theme-img--collage-last');
    }
  }

  function replaceMedia(variantId) {
    const tpl = document.getElementById(`variant-media-${variantId}`);
    const gallery = document.querySelector('.js-variant-gallery');
    if (!tpl || !gallery) return;

    // Replace gallery content
    gallery.innerHTML = tpl.innerHTML;

    // Lazyload
    if (window.lazySizes) lazySizes.autoSizer.checkElems();

    // Lấy viewport
    const viewport = gallery.closest('.theme-viewport');
    const galleryWrapper = viewport.closest('.theme-gallery');

    // Re-init Swiper/Zoom
    if (window.theme && typeof window.theme.ProductMediaGallery === 'function') {
      const $viewport = $(viewport);
      const $thumbs = $viewport.closest('.product-area').find('.product-area__thumbs');
      const galleryId = $viewport.closest('[data-section-id]').data('section-id') || Date.now();
      new window.theme.ProductMediaGallery($viewport, $thumbs, false, false, galleryId);
    }

    // Rebuild columns thủ công
    rebuildColumns($(galleryWrapper));

    // Trigger resize để theme tự căn layout
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      $(window).trigger('debouncedresize');
    }, 100);
  }

  // Nghe sự kiện đổi variant
  $(window).on('cc-variant-updated', function (e, data) {
    if (!data || !data.variant) return;
    replaceMedia(data.variant.id);
  });
});
